import React from 'react';
import { AuthContext } from '../../authContext';
const useIdentityRoles = () => {
    const { identityRoles } = React.useContext(AuthContext);
    return React.useMemo(() => identityRoles.reduce((aggr, item) => ({
        ...aggr,
        [item]: true,
    }), {}), [identityRoles]);
};
export default useIdentityRoles;
